/*! Wi-users - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

var url_users, url_users_view, url_users_save, url_users_create_user;
var group_id = 0;

+function ($) {
    'use strict';
    var wiUsers = window.wiUsers;
    window.wiUsers = {
        init: function () {
            wiUsers.events();
        },
        refresh: function () {
        },
        events: function () {
            $(document).on('show.bs.tab', '.tab-contacts', function () {
                var ajaxloaded = $(this).attr('data-ajax-loaded');
                if (ajaxloaded === 'false') {
                    $(this).attr('data-ajax-loaded', true);
                    wiVars.set.variable('subreferral_id', 0);
                    wiVars.set.variable('subreferral_type', '');
                    wiVars.set.variables();
                    wiUsers.get.users();
                }
            });
            $(document).on('click', '.usermanager', function (event) {
                event.preventDefault();

                var click = $(this).attr('data-click');
                if (click) {
                    if ($(click).length) {
                        $(click).trigger('click');
                    }
                }
                wiModal.get({
                    modal: 'usermanager_modal',
                    module: 'users/users_access',
                    url: 'users',
                    language_id: language_id,
                    referral_id: referral_id,
                    referral_type: referral_type,
                    subreferral_id: subreferral_id,
                    subreferral_type: subreferral_type
                });

            });
            $(document).on('change', '#usermanager_form #user_group', function () {
                    group_id = $(this).val();
                    $('#usermanager_search').val('');
                    wiUsers.get.view();
                });

                var usermanagerSearchTimer;
                $(document).on('input', '#usermanager_search', function () {
                    clearTimeout(usermanagerSearchTimer);
                    var q = $(this).val();
                    usermanagerSearchTimer = setTimeout(function () {
                        wiUsers.get.view(q);
                    }, 300);
                });

                $(document).on('change', "#usermanager_user_list #checkall", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    $(".users-checkbox").prop('checked', $(this).prop("checked"));
                });

                $(document).on('click', "#usermanager_modal_btn", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var checked_ids = wiUsers.get.checkedUsers();
                    var visible_ids = wiUsers.get.visibleUsers();

                    $.ajax({
                        url: url_users_save,
                        type: 'POST',
                        data: {
                            users_id: checked_ids,
                            visible_ids: visible_ids,
                            language_id: language_id,
                            referral_id: referral_id,
                            referral_type: referral_type,
                            subreferral_id: subreferral_id,
                            subreferral_type: subreferral_type,
                            group_id: group_id,
                            csrf_wicode: csrf_value
                        },
                        success: function (response) {
                            $('.wicode-modal .validation').html('');
                            if (response.status === 'success') {
                                wiUsers.get.users();
                                $('#usermanager_modal').modal('hide');
                            } else {
                                $('.wicode-modal .validation').append(response.msg);
                            }
                        }
                    });

                });
                $(document).on('click', ".create-user", function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    wiModal.get({
                        modal: 'create_modal',
                        module: 'users/users_access',
                        language_id: language_id,
                        group_id: group_id,
                        referral_id: referral_id,
                        referral_type: referral_type,
                        subreferral_id: subreferral_id,
                        subreferral_type: subreferral_type
                    });

                });
                $(document).on('submit', ".create-form", function (event) {
                    event.preventDefault();
                    var form = $(this);
                    var formData = form.serializeArray();

                    $.ajax({
                        url: url_users_create_user,
                        type: 'POST',
                        data: formData,
                        success: function (jData) {
                            if (jData.status === 'success') {
                                wiUsers.get.view();
                                $('#create_modal').modal('hide');
                            }
                            wiAlerts.add(jData.status, jData.title, jData.msg);
                        }
                    });
                });
        },
        get: {
            users: function () {
                $.get(
                        url_users,
                        {
                            language_id: language_id,
                            referral_id: referral_id,
                            referral_type: referral_type,
                            subreferral_id: subreferral_id,
                            subreferral_type: subreferral_type,
                            csrf_wicode: csrf_value
                        },
                        function (data) {
                            var users_area = $('#users_area');
                            if (users_area.length) {
                                users_area.html(data.users);
                            }
                            var contacts_area = $('#contacts_area');
                            if (contacts_area.length) {
                                contacts_area.html(data.contacts);
                            }
                        }
                );
            },
            view: function (q) {
                $.get(url_users_view, {
                    language_id: language_id,
                    referral_id: referral_id,
                    referral_type: referral_type,
                    group_id: group_id,
                    q: q || ''
                }, function (respond) {
                    $('#usermanager_user_list').html(respond.view);
                    $('#usermanager_search_row').show();
                });

            },
            checkedUsers: function () {
                return $('.users-checkbox:checked').map(function () {
                    return this.value;
                }).get();
            },
            visibleUsers: function () {
                return $('.users-checkbox').map(function () {
                    return this.value;
                }).get();
            }
        }
    };
    $(function () {
        url_users = urls.users + '/access/get_users';
        url_users_view = urls.site + 'api/users/search';
        url_users_save = urls.users + '/access/save_users_project';
        url_users_create_user = urls.users + '/access/create_user';

        wiUsers = window.wiUsers;
        wiUsers.init();
    });
}(jQuery);
